 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"common":"common","default~auth-auth-module~customer-orders-customer-order-detail-customer-order-detail-module~customer~37888456":"default~auth-auth-module~customer-orders-customer-order-detail-customer-order-detail-module~customer~37888456","auth-auth-module":"auth-auth-module","dashboard-active-work-orders-active-work-orders-module":"dashboard-active-work-orders-active-work-orders-module","dashboard-dashboard-module":"dashboard-dashboard-module","dashboard-outstanding-customer-orders-outstanding-customer-orders-module":"dashboard-outstanding-customer-orders-outstanding-customer-orders-module","dashboard-outstanding-mails-outstanding-mails-module":"dashboard-outstanding-mails-outstanding-mails-module","dashboard-outstanding-notes-outstanding-notes-module":"dashboard-outstanding-notes-outstanding-notes-module","dashboard-outstanding-preliminary-customer-orders-outstanding-preliminary-customer-orders-module":"dashboard-outstanding-preliminary-customer-orders-outstanding-preliminary-customer-orders-module","dashboard-outstanding-purchase-invoices-outstanding-purchase-invoices-module":"dashboard-outstanding-purchase-invoices-outstanding-purchase-invoices-module","dashboard-outstanding-quotations-employees-outstanding-quotations-employees-module":"dashboard-outstanding-quotations-employees-outstanding-quotations-employees-module","dashboard-outstanding-quotations-status-outstanding-quotations-status-module":"dashboard-outstanding-quotations-status-outstanding-quotations-status-module","dashboard-outstanding-sales-invoices-outstanding-sales-invoices-module":"dashboard-outstanding-sales-invoices-outstanding-sales-invoices-module","dashboard-outstanding-sales-opportunities-outstanding-sales-opportunities-module":"dashboard-outstanding-sales-opportunities-outstanding-sales-opportunities-module","dashboard-outstanding-work-orders-outstanding-work-orders-module":"dashboard-outstanding-work-orders-outstanding-work-orders-module","notes-note-detail-note-detail-module":"notes-note-detail-note-detail-module","sales-payments-sales-payment-detail-sales-payment-detail-module":"sales-payments-sales-payment-detail-sales-payment-detail-module","sales-payments-sales-payments-sales-payments-module":"sales-payments-sales-payments-sales-payments-module","dashboard-day-day-module":"dashboard-day-day-module","default~customer-orders-customer-order-detail-customer-order-detail-module~customer-orders-customer-~83f3891f":"default~customer-orders-customer-order-detail-customer-order-detail-module~customer-orders-customer-~83f3891f","customer-orders-customer-order-detail-customer-order-detail-module":"customer-orders-customer-order-detail-customer-order-detail-module","customer-orders-customer-orders-customer-orders-module":"customer-orders-customer-orders-customer-orders-module","default~dashboard-annual-sales-annual-sales-module~dashboard-monthly-sales-monthly-sales-module":"default~dashboard-annual-sales-annual-sales-module~dashboard-monthly-sales-monthly-sales-module","dashboard-annual-sales-annual-sales-module":"dashboard-annual-sales-annual-sales-module","dashboard-monthly-sales-monthly-sales-module":"dashboard-monthly-sales-monthly-sales-module","default~delivery-notes-delivery-note-detail-delivery-note-detail-module~delivery-notes-delivery-note~927fe16f":"default~delivery-notes-delivery-note-detail-delivery-note-detail-module~delivery-notes-delivery-note~927fe16f","delivery-notes-delivery-note-detail-delivery-note-detail-module":"delivery-notes-delivery-note-detail-delivery-note-detail-module","delivery-notes-delivery-notes-delivery-notes-module":"delivery-notes-delivery-notes-delivery-notes-module","default~preliminary-customer-orders-preliminary-customer-order-detail-preliminary-customer-order-det~b316d271":"default~preliminary-customer-orders-preliminary-customer-order-detail-preliminary-customer-order-det~b316d271","preliminary-customer-orders-preliminary-customer-order-detail-preliminary-customer-order-detail-module":"preliminary-customer-orders-preliminary-customer-order-detail-preliminary-customer-order-detail-module","preliminary-customer-orders-preliminary-customer-orders-preliminary-customer-orders-module":"preliminary-customer-orders-preliminary-customer-orders-preliminary-customer-orders-module","default~purchase-invoices-purchase-credit-notes-purchase-credit-notes-module~purchase-invoices-purch~5854c1b4":"default~purchase-invoices-purchase-credit-notes-purchase-credit-notes-module~purchase-invoices-purch~5854c1b4","purchase-invoices-purchase-credit-notes-purchase-credit-notes-module":"purchase-invoices-purchase-credit-notes-purchase-credit-notes-module","purchase-invoices-purchase-invoices-purchase-invoices-module":"purchase-invoices-purchase-invoices-purchase-invoices-module","default~quotations-quotation-detail-quotation-detail-module~quotations-quotations-quotations-module":"default~quotations-quotation-detail-quotation-detail-module~quotations-quotations-quotations-module","quotations-quotation-detail-quotation-detail-module":"quotations-quotation-detail-quotation-detail-module","quotations-quotations-quotations-module":"quotations-quotations-quotations-module","default~sales-invoices-sales-credit-notes-sales-credit-notes-module~sales-invoices-sales-invoice-det~b987a5f2":"default~sales-invoices-sales-credit-notes-sales-credit-notes-module~sales-invoices-sales-invoice-det~b987a5f2","sales-invoices-sales-credit-notes-sales-credit-notes-module":"sales-invoices-sales-credit-notes-sales-credit-notes-module","sales-invoices-sales-invoices-sales-invoices-module":"sales-invoices-sales-invoices-sales-invoices-module","sales-invoices-sales-invoice-detail-sales-invoice-detail-module":"sales-invoices-sales-invoice-detail-sales-invoice-detail-module","default~sales-opportunities-sales-opportunities-sales-opportunities-module~sales-opportunities-sales~d773a545":"default~sales-opportunities-sales-opportunities-sales-opportunities-module~sales-opportunities-sales~d773a545","sales-opportunities-sales-opportunities-sales-opportunities-module":"sales-opportunities-sales-opportunities-sales-opportunities-module","sales-opportunities-sales-opportunity-detail-sales-opportunity-detail-module":"sales-opportunities-sales-opportunity-detail-sales-opportunity-detail-module","info-info-module":"info-info-module","mails-mail-detail-mail-detail-module":"mails-mail-detail-mail-detail-module","mails-mails-mails-module":"mails-mails-mails-module","notes-notes-notes-module":"notes-notes-notes-module","purchase-orders-purchase-orders-purchase-orders-module":"purchase-orders-purchase-orders-purchase-orders-module","relations-relation-detail-address-detail-address-detail-module":"relations-relation-detail-address-detail-address-detail-module","relations-relation-detail-relation-detail-module":"relations-relation-detail-relation-detail-module","relations-relations-relations-module":"relations-relations-relations-module","work-orders-work-order-detail-work-order-detail-module":"work-orders-work-order-detail-work-order-detail-module","work-orders-work-orders-work-orders-module":"work-orders-work-orders-work-orders-module","polyfills-core-js":"polyfills-core-js","polyfills-css-shim":"polyfills-css-shim","polyfills-dom":"polyfills-dom","shadow-css-93af91ae-js":"shadow-css-93af91ae-js","swiper-bundle-f564f87c-js":"swiper-bundle-f564f87c-js","focus-visible-15ada7f7-js":"focus-visible-15ada7f7-js","index-120c8c20-js":"index-120c8c20-js","input-shims-77712174-js":"input-shims-77712174-js","status-tap-6a77b957-js":"status-tap-6a77b957-js","swipe-back-7b4b8b66-js":"swipe-back-7b4b8b66-js","tap-click-252af35a-js":"tap-click-252af35a-js"}[chunkId]||chunkId) + "-es2015.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
